export enum ComponentWidth {
    mediumColumn = '275px',
    largeColumn = '350px',
    smallColumn = '120px',
    extraSmallColumn = '90px'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/component-width.enum.ts